import { useContext } from 'react';
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';
import Button from '../../../../components/Button';
import CancelButton from '../../../../components/CancelButton';
import InputField from '../../../../components/InputField';
import LanguageField from '../../../../components/LanguageField';
import LocaleField from '../../../../components/LocaleField';
import { CountryCodeField, PhoneInputField } from '../../../../components/PhoneInputField';
import TimezoneField from '../../../../components/TimezoneField';
import GeneralEditContext from './GeneralEditContext';
import { desktopCSS, phoneNumberFieldCSS, saveCancelActionsCSS } from './generalEditCSS';

const GeneralEditDesktop = () => {
    const {
        firstName,
        onFirstNameChange,
        onLastNameChange,
        lastName,
        phone,
        phoneDisabled,
        phoneError,
        onPhoneChange,
        countryCode,
        countryCodeError,
        countries,
        onCountryCodeChange,
        onLanguageChange,
        onLocaleChange,
        onTimezoneChange,
        language,
        locale,
        timezone,
        options,
        onSave,
        onCancel,
        saveButtonDisabled,
        fieldLabels: {
            cancelLabel,
            countryCodeLabel,
            firstNameLabel,
            lastNameLabel,
            languageLabel,
            localeLabel,
            mobilePhoneLabel,
            saveLabel,
            timezoneLabel,
        },
    } = useContext(GeneralEditContext);

    const { languages, locales, timezones } = options;

    return (
        <div css={desktopCSS}>
            <InputField
                label={`${firstNameLabel}*`}
                onChange={onFirstNameChange}
                value={firstName}
            />
            <InputField label={`${lastNameLabel}*`} onChange={onLastNameChange} value={lastName} />
            <EmotionThemeProvider theme={{ selectFieldInputWidth: '16.667rem' }}>
                <div css={phoneNumberFieldCSS}>
                    <CountryCodeField
                        countries={countries}
                        label={countryCodeLabel}
                        value={countryCode}
                        onChange={onCountryCodeChange}
                        errorMessage={countryCodeError}
                    />
                    <PhoneInputField
                        label={mobilePhoneLabel}
                        value={phone}
                        onChange={onPhoneChange}
                        errorMessage={phoneError}
                        disabled={phoneDisabled}
                    />
                </div>
            </EmotionThemeProvider>
            <LanguageField
                label={languageLabel}
                languages={languages}
                onChange={onLanguageChange}
                value={language}
            />
            <LocaleField
                label={localeLabel}
                locales={locales}
                onChange={onLocaleChange}
                value={locale}
            />
            <TimezoneField
                label={timezoneLabel}
                onChange={onTimezoneChange}
                timezones={timezones}
                value={timezone}
            />
            <div css={saveCancelActionsCSS}>
                <CancelButton label={cancelLabel} onClick={onCancel} />
                <Button disabled={saveButtonDisabled} onClick={onSave}>
                    {saveLabel}
                </Button>
            </div>
        </div>
    );
};

export default GeneralEditDesktop;
